import { render, staticRenderFns } from "./RecruiterPersonInterviewDetails.vue?vue&type=template&id=2be71628&scoped=true"
import script from "./RecruiterPersonInterviewDetails.vue?vue&type=script&lang=ts"
export * from "./RecruiterPersonInterviewDetails.vue?vue&type=script&lang=ts"
import style0 from "./RecruiterPersonInterviewDetails.vue?vue&type=style&index=0&id=2be71628&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be71628",
  null
  
)

export default component.exports